module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_8011.456b7af5.png";